<p-tabView *ngIf="customers && api.adminUser.value" [(activeIndex)]="tabIndex">
    <p-tabPanel header="Commandes sauvegardées" >
        <app-saved-orders [customers]="customers" (orderCharged)="chargeOrder($event)"></app-saved-orders>
    </p-tabPanel>
    <p-tabPanel header="Nouvelle commande">

    	<h1 class="text-center">Nouvelle commande<small *ngIf="api.order && api.order.customer && api.order.customer.Name"> - {{api.order.customer.Name}}</small></h1>

    	<p-steps [activeIndex]="stepIndex" [model]="items" styleClass="mb-4" [readonly]="false" (activeIndexChange)="changeIndex($event)"></p-steps>
    	
      <div class="flex justify-content-center"  *ngIf="stepIndex != 0 && (!customer || !api.order.customer.Name)">
         <p-message severity="error" text="Vous devez choisir un client à l'étape 1"></p-message>
     </div>

     <div *ngIf="stepIndex === 0" >
      <div class="flex justify-content-center pt-5 gap-2">
         <p-dropdown (onChange)="loading = true; api.clearCart(true)" styleClass="w-30rem" [filter]="true" (onShow)="customer = undefined" placeholder="Choisissez un client" [options]="customers" optionLabel="Name" [(ngModel)]="customer" [virtualScroll]="true" [virtualScrollItemSize]="38">
              <ng-template let-c pTemplate="item">
                <div class="">
                    {{c.Id}} - {{c.Name}}
                </div>
            </ng-template>
         </p-dropdown>
     </div>
     <div *ngIf="customer && api.order.customer.Name">
         <div class="flex justify-content-center mt-4 gap-2">
           <p-message severity="info" text="Ajoutez ici une nouvelle adresse, vous pourrez la selectionner lors de la validation de la commande"></p-message>
           <button (click)="changeIndex(1)" icon="pi {{loading ? 'pi-spin pi-spinner' : 'pi-chevron-right'}}" pButton pRipple label="Étape suivante" class="w-auto" [disabled]="!customer || !api.order.customer.Name" [disabled]="!api.texts"></button>

       </div>
       <app-my-account></app-my-account>
   </div>
</div>

<div *ngIf="stepIndex === 1">
  <div class="flex justify-content-start gap-2 mb-2" *ngIf="customer && api.order.customer.Name">
     <button pButton label="Ajout article" icon="pi pi-plus" (click)="api.displayFast = true"></button>
     <p-dropdown (onChange)="addText($event.value)" [options]="texts" optionLabel="Caption" [filter]="true" placeholder="Ajoutez une ligne de texte"></p-dropdown>
     <app-bdc *ngIf="api.adminOrder"></app-bdc>
    <div class="ml-6">  
        <div class="p-inputgroup" >
            <p-inputNumber [min]="-100" [max]="100" mode="decimal" [minFractionDigits]="2" inputStyleClass="w-6rem"  [(ngModel)]="api.order.DiscountRate" (onInput)="api.totalOrder()"></p-inputNumber>
            <span class="p-inputgroup-addon">% remise globale</span>
        </div>
    </div>
    <button pButton label="Tout passer en dotation festival"  (click)="allDotation()"></button>

 </div>
 <app-order *ngIf="customer && api.order.customer.Name" (textAdded)="addTextLine($event)"></app-order>
</div>

<app-login *ngIf="customer" [fromAdmin]="customer" (isInit)="loginInit()"></app-login>

</p-tabPanel>
<p-tabPanel header="Mes devis">
    <app-quotes *ngIf="tabIndex == 2" (orderCharged)="chargeOrder($event)" [fromPro]="0"></app-quotes>
</p-tabPanel>
<p-tabPanel header="Devis créés par mes clients">
    <app-quotes *ngIf="tabIndex == 3" (orderCharged)="chargeOrder($event)" [fromPro]="1"></app-quotes>
</p-tabPanel>
<p-tabPanel header="Demandes d'avoir">
    <app-credit-requests *ngIf="tabIndex == 4"></app-credit-requests>
</p-tabPanel>
</p-tabView>

<p-dialog [(visible)]="customerAlert.display" [modal]="true" [position]="'top'">
    <p-header>
        Alerte(s) client
    </p-header>
    <div *ngFor="let a of customerAlert.alerts">
        <p-messages [severity]="a.severity" [closable]="false">
            <ng-template pTemplate>
                <div>
                    <h4 class="m-0">{{a.summary}}</h4>
                    <div [innerHtml]="a.detail"></div>
                </div>
                <div class="flex gap-2 ml-2">
                    <button pButton (click)="disableAlert(a)" label="Désactiver" class="p-button-sm p-button-warn"></button>
                    <button type="button" pButton (click)="selectedAlert = a; displayModifyAlert = true;" label="Modifier" class="p-button-sm p-button-info"></button>
                </div>
            </ng-template>
        </p-messages>
    </div>
</p-dialog>

<p-dialog [header]="'Modifier alerte / note'" [(visible)]="displayModifyAlert" [modal]="true" [style]="{width:'500px'}" [position]="'top'">
    <div *ngIf="selectedAlert">
        <h5>Titre</h5>
        <input id="float-input" type="text" size="30" pInputText [(ngModel)]="selectedAlert.summary"> 

        <h5>Détails</h5>
        <textarea class="w-full" [rows]="5" [cols]="30" pInputTextarea [(ngModel)]="selectedAlert.detail"></textarea>

        <div style="margin-top: 25px;">
            <p-checkbox label="Alerte sur commande" [trueValue]="'1'" [falseValue]="'0'" [(ngModel)]="selectedAlert.onOrder" [binary]="true"></p-checkbox>
        </div>
        <div>
            <p-checkbox label="Alerte sur fiche client" [trueValue]="'1'" [falseValue]="'0'" [(ngModel)]="selectedAlert.onCustomer" [binary]="true"></p-checkbox>
        </div>
    </div>
        
    <p-footer>
        <button type="button" pButton icon="pi pi-check" (click)="modifyAlert()" label="Enregistrer" ></button>
        <button type="button" pButton icon="pi pi-times" class="p-button-danger" (click)="displayModifyAlert=false" label="Annuler"></button>
    </p-footer>
</p-dialog>